import React from 'react'
import { LoaderCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

class LoadMore extends React.Component {

  loadmoreRef = React.createRef()

  componentDidMount() {
    this.onObserve()
  }

  componentWillUnmount() {
    this.onStopObserving()
  }

  onObserve = () => {
    if (IntersectionObserver !== undefined) {
      const el = this.loadmoreRef.current
      const onLoadMore = this.onLoadMore

      if (el) {
        this.observer = new IntersectionObserver(function(entries, observer) {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              onLoadMore()
            }
          })
        }, {
          rootMargin: '0px',
          threshold: 1.0
        })

        this.observer.observe(el)
      }
    }
  }

  onStopObserving = () => {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  onLoadMore = () => {
    if (this.props.loading) {
      return
    }

    this.props.onLoadMore(this.props.page + 1)
  }

  render() {
    if (this.props.loading == true) {
      return (
        <Button ref={this.loadmoreRef} variant="link" className="w-full">
          <LoaderCircle className="animate-spin" />
        </Button>
      )
    }
    else {
      return (
        <Button ref={this.loadmoreRef} variant="link" className="w-full" onClick={this.onLoadMore}>
          Load More
        </Button>
      )
    }
  }
}

export default LoadMore
